import * as URL from "../../helpers/Constants";
import axios from "axios";

export default class PMSPatientServices {

    static getAllPatientsByPharmacyId(pharmacyId, params) {
        return axios.get(`${URL.PMS_GET_ALL_PATIENTS_BY_PHARMACY_ID}/${pharmacyId}`, {
            ...PMSPatientServices.getAuthHeader(),
            params,
        });
    }

    static getPatientById(pharmacyId, id) {
        return axios.get(`${URL.PMS_GET_PATIENT_BY_ID}/${id}/${pharmacyId}`, PMSPatientServices.getAuthHeader());
    }

    static createPatient(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_PATIENT_BY_PHARMACY_ID}/${pharmacyId}`, data, PMSPatientServices.getAuthHeader());
    }

    static updatePatientById(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_PATIENT_BY_ID}/${id}/${pharmacyId}`, data, PMSPatientServices.getAuthHeader());
    }

    static deletePatientById(id, pharmacyId) {
        return axios.delete(`${URL.PMS_DELETE_PATIENT_BY_ID}/${id}/${pharmacyId}`, PMSPatientServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
